export function depthFirstSearch<T, K extends keyof T>(
    node: T,
    idProp: K,
    vertexProp: keyof T,
    visited: Partial<Record<any, boolean>> = {},
): T[] {
    const result: T[] = [];

    const dfs = (currentNode: T): void => {
        if (!currentNode || visited[currentNode[idProp]]) {
            return;
        }

        // eslint-disable-next-line no-param-reassign
        visited[currentNode[idProp] as any] = true;
        result.push(currentNode);

        (currentNode[vertexProp] as unknown as Array<T>)?.forEach((neighbor) => {
            dfs(neighbor);
        });
    };

    dfs(node);

    return result;
}
